<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref=""></ion-back-button>
    </ion-buttons>
    <ion-title>
      <span translate>Colors</span>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item *ngFor="let driver of drivers; let id = index">
      <number slot="start" [color]="driver.color">
        {{id + 1}}
      </number>
      <ion-label>
        {{driver.name || (placeholder | translate:{number: id + 1})}}
      </ion-label>
      <input [(ngModel)]="driver.color" type="color" [style.zIndex]="100">
    </ion-item>
  </ion-list>
</ion-content>
